// src/utils/mfaNotify.js
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebaseConfig";

/**
 * Envía correo de notificación MFA (2FA) vía Cloud Function `sendMfaNotification`.
 *
 * @param {Object} params
 * @param {"enabled"|"disabled"} params.action  - Acción realizada
 * @param {"totp"|"sms"} params.factor          - Tipo de factor
 * @param {string=} params.factorLabel          - Etiqueta (Ej: "Google Authenticator", "Authy", "SMS")
 * @param {string=} params.device               - Info del dispositivo/navegador
 * @param {string=} params.ip                   - IP (opcional si no la tienes)
 * @returns {Promise<{ok: boolean}>}
 */
export async function notifyMfaEmail({
  action,
  factor,
  factorLabel = "",
  device = "",
  ip = "",
}) {
  if (!action || !factor) {
    throw new Error("notifyMfaEmail: 'action' y 'factor' son obligatorios.");
  }

  const callable = httpsCallable(functions, "sendMfaNotification");

  const payload = {
    action,
    factor,
    factorLabel,
    device,
    ip,
  };

  const res = await callable(payload);
  // Firebase devuelve { data: ... }
  return res?.data || { ok: false };
}

/**
 * Helper para armar un "device" básico con el navegador.
 * (Opcional; úsalo si quieres mantener limpio el componente)
 */
export function getDeviceInfo() {
  try {
    return navigator.userAgent || "";
  } catch {
    return "";
  }
}
